"use client"

import { Col, Row, RowProps, Skeleton } from "antd";
import { useIsDesktop } from "@/hooks/app/useIsDesktop";

const BannerDealsSkeleton = (props: RowProps) => {
  const isDesktop = useIsDesktop()

  return (
    <Row {...props} className="home__deals-hotels--box" justify='center' style={{ padding: 0, marginBottom: '3rem', ...props.style }}>
      <Col span={24} className="home__deals--box" style={{ padding: 0 }}>
        <Skeleton
          paragraph={false}
          active
          styles={{
            title: {
              width: '100%',
              height: !isDesktop ? "13rem" : "26rem",
              margin: 0,
              marginBottom: '3rem'
            }
          }}
        />
      </Col>
    </Row>
  );
};

export default BannerDealsSkeleton;
